import { ChannelProvider } from "@pandas/realtime";
import { visionAblyChannelName } from "@pandas/realtime/shared";
import { createFileRoute } from "@tanstack/react-router";
import TradeInCompletionOnVision from "@/features/tradein/pages/trade-in-completion-on-vision/TradeInCompletionOnVision";
import { useStore } from "@/store";

function TradeInCompletionOnVisionRoute() {
	const sessionId = useStore((state) => state.sessionId);
	const channelName = visionAblyChannelName(sessionId);
	return (
		<ChannelProvider channelName={channelName}>
			<TradeInCompletionOnVision />
		</ChannelProvider>
	);
}

export const Route = createFileRoute("/$locale/$partner/_trade-in/trade-in-completion-on-vision")({
	component: TradeInCompletionOnVisionRoute,
});
